{
  "id": "campaign-122",
  "name": "Final Ground",
  "seed": "campaign:122",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "r....QQQQ....r",
    "..:.....,..:..",
    "..:..#.,,,.:..",
    ".#::::::::::..",
    "....~...,,,.x.",
    "...~~~.#.,....",
    "....~........#",
    "::::::::::::::",
    "..x....#..x...",
    ".....x.......x",
    "...#....x..#..",
    "..::::::::::..",
    "..:..#....x:..",
    "..:........:..",
    "S....QQQQ....."
  ],
  "critters": [
    {
      "kind": "rabbit",
      "x": 5,
      "y": 11
    },
    {
      "kind": "squirrel",
      "x": 1,
      "y": 4
    },
    {
      "kind": "rabbit",
      "x": 10,
      "y": 7
    },
    {
      "kind": "rabbit",
      "x": 12,
      "y": 14
    },
    {
      "kind": "squirrel",
      "x": 2,
      "y": 10
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 9,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 13,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 12,
      "y": 13
    }
  ],
  "generatorVersion": 3,
  "level": 122,
  "biome": "stadium",
  "par": {
    "reel": 6409,
    "push": 5945,
    "selfPropelled": 5268,
    "tractor": 4220,
    "zeroTurn": 3874,
    "fairway": 2065
  },
  "goldTime": {
    "reel": 6409,
    "push": 5919,
    "selfPropelled": 5268,
    "tractor": 4220,
    "zeroTurn": 3858,
    "fairway": 1933
  },
  "routeTries": {
    "par": {
      "reel": 18,
      "push": 21,
      "selfPropelled": 24,
      "tractor": 8,
      "zeroTurn": 12,
      "fairway": 2
    },
    "gold": {
      "reel": 18,
      "push": 42,
      "selfPropelled": 24,
      "tractor": 8,
      "zeroTurn": 45,
      "fairway": 27
    }
  }
}
